import { render, staticRenderFns } from "./StatisticsMap.vue?vue&type=template&id=68ddd29d"
import script from "./StatisticsMap.vue?vue&type=script&lang=js"
export * from "./StatisticsMap.vue?vue&type=script&lang=js"
import style0 from "./StatisticsMap.vue?vue&type=style&index=0&id=68ddd29d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports